import { Drawer as MantineDrawer } from '@mantine/core';

export const Drawer = MantineDrawer.extend({
	defaultProps: {
		variant: 'primary',
		transitionProps: {
			transition: {
				transitionProperty: 'transform, opacity',
				in: { transform: 'translateX(0)', opacity: 1 },
				out: { transform: 'translateX(-100%)', opacity: 0 },
			},
			duration: 200,
			timingFunction: 'ease-in-out',
		},
		returnFocus: false,
		withCloseButton: false,
		portalProps: {},
	},
});
